// Page for users with the 'none' role
// - Waits for Firebase users to load
// - Finds a user by :noneId locally
// - Shows Spinner while loading
// - Renders <h1> error if user is not found

import { useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import NoneCard from '../components/NoneCard';
import Spinner from '../components/Spinner';
import { useUser } from '../utils/hooks';
import { UsersRoles } from '../utils/enums';

export default function PageNone() {
  const { noneId } = useParams();
  const { entity: found, isResolved } = useUser(noneId);

  // Find the user by id and role
  const none = found?.role === UsersRoles.NONE ? found : undefined;

  // Spinner only while the record could still show up — the current user's own
  // card is already in usersById, so it renders without waiting for the list
  if (!none && !isResolved) {
    return (
      <Layout screenSized className='page-none'>
        <Spinner show />
      </Layout>
    );
  }

  // Not found => plain H1 error
  if (!none) {
    return (
      <Layout screenSized className='page-none'>
        <h1>{`Error: no route matches url "/none/${noneId}"`}</h1>
      </Layout>
    );
  }

  // Happy path
  return (
    <Layout className='page-none' trail>
      <NoneCard none={none} />
    </Layout>
  );
}
